
class LoginRegisterTabs extends HTMLElement{
    constructor(){
        super();

        this.tabLinks = this.querySelectorAll('.login-register-tabs__tablinks');

        this.tabLinks.forEach(tabLink => {
            let tabName = tabLink.getAttribute('data-tab-name');
            tabLink.addEventListener('click', () =>{
                this.openTab(event, tabName)            
            })
        });
        
        document.getElementById("defaultOpen").click();
    }
    
    openTab(evt, tabName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("login-register-tabs__tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("login-register-tabs__tablinks");
        for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(tabName).style.display = "block";
        evt.currentTarget.className += " active";
      }
}

customElements.define('login-register-tabs', LoginRegisterTabs);